export enum ClaimStatus {
  CurrentUserCanClaim = 0,
  ClaimedByCurrentUser = 1,
  ClaimedByAnotherUser = 2,
  UnableToClaim = 3,
}

export enum WorkflowStageApprovalType {
  Serial = 1,
  Parallel = 2,
}

export enum EffectiveStatusType {
  WaitingToBeEffective = 1,
  Effective = 2,
}

export enum ProcessingType {
  Review = 1,
  Approval = 2,
  Signature = 3,
}
